export default __webpack_public_path__ + "static/media/005.f13d648a.png";